import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es formato papel o digital?',
    a: 'Es un producto 100% digital (PDF de Alta Resolución) que reúne 6 libros en 1, optimizado para consultar en iPad, Tablet o Smartphone durante tus clases.'
  }, {
    q: '¿Hay que ser experta para usar este sistema?',
    a: 'No. Está diseñado tanto para instructoras nuevas que buscan seguridad, como para expertas que quieren ahorrar tiempo. Cada secuencia se explica paso a paso.'
  }, {
    q: '¿Sirve para Reformer y Mat?',
    a: 'Sí. Los tomos cubren ambos formatos y el uso de pequeños elementos (bandas, pelotas, aros).'
  }];
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-pilates-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-54">
      <div className="max-w-3xl mx-auto" data-id="element-55">
        <div className="text-center mb-12" data-id="element-56">
          <div className="bg-pilates-sage/15 text-pilates-sage-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-57">
            Preguntas Frecuentes
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight tracking-tight" data-id="element-58">
            Respondemos a{' '}
            <span className="italic text-pilates-rose" data-id="element-59">tus preguntas</span>
          </h2>
        </div>

        <div className="space-y-3" data-id="element-60">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-2xl border border-pilates-sage/20 overflow-hidden shadow-sm" data-id="element-61">
              <button onClick={() => setOpen(open === idx ? null : idx)} className="w-full flex items-center justify-between p-5 text-left hover:bg-pilates-cream/40 transition-colors" data-id="element-62">
                <span className="font-display font-semibold text-pilates-dark text-base sm:text-lg pr-4" data-id="element-63">
                  {faq.q}
                </span>
                <div className="flex-shrink-0 bg-pilates-sage-dark text-white w-8 h-8 rounded-full flex items-center justify-center" data-id="element-64">
                  {open === idx ? <Minus className="w-4 h-4" data-id="element-65" /> : <Plus className="w-4 h-4" data-id="element-66" />}
                </div>
              </button>
              {open === idx && <div className="px-5 pb-5 text-pilates-slate leading-relaxed" data-id="element-67">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}